import React from 'react';

const VideoGallery = () => {
  return (
    <div style={{ paddingTop: '100px', minHeight: '100vh', padding: '20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>영상홍보관</h1>
        <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666' }}>
          영상홍보관 페이지입니다.
        </p>
      </div>
    </div>
  );
};

export default VideoGallery;